import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.main.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  position: relative;
  width: 100%;

  overflow: auto;
  flex: 1;

  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 1.5rem;

  @media screen and (max-width: 1275px) {
    flex: 1;
    grid-template-columns: 1fr;
  }

  ${VerticalStyledScrollBar}
`

export const AdditionalInformationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const ErrorTitle = styled.h3`
  margin-top: 2rem;
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.8px;
`

export const ErrorDescription = styled.p`
  margin-top: 1rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: pre-wrap;
`
